export const templatesTextCardFootnote = (workspacesCount: number, downloadableTemplateType: string) => {
  if (workspacesCount > 1) {
    return `${workspacesCount} workspaces`
  }
  // else
  switch (downloadableTemplateType) {
    case 'Docs Template':
      return 'Docs'
    case 'Slides Template':
      return 'Slides'
  }

  // neither workspacesCount > 1 nor downloadable template
  return ''
}

export const getDownloadableTemplateData = (downloadableTemplateType?: string) => {
  switch (downloadableTemplateType) {
    case 'Docs Template':
      return { templateType: 'Doc', templateTypeIconSrc: 'docs-logo' }
    case 'Slides Template':
      return { templateType: 'Slides', templateTypeIconSrc: 'slides-logo' }
    default:
      return { templateType: 'Doc', templateTypeIconSrc: 'docs-logo' }
  }
}

export const addTemplateToTemplateName = (templateName: string) => {
  const [name, by] = templateName.split(' by ')
  return `${name} template ${by ? ' by ' + by : ''}`
}

export const getLowerCaseTemplateName = (templateName: string) => {
  switch (true) {
    case templateName.startsWith('GIST'):
    case templateName.startsWith('GO'):
    case templateName.startsWith('RICE'):
    case templateName.startsWith('LICE'):
    case templateName.startsWith('ICE'):
    case templateName.startsWith('WSJF'):
      return templateName
    case templateName.includes('PRD'):
    case templateName.includes('OKRs'):
      return templateName.replace(/^\w+/, (match) => match.toLowerCase())
    default:
      return templateName.toLowerCase()
  }
}
